import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class GuidedOnboardingDataManagerPopularTour extends TourBase {
	@service('flow/tour/onboarding')
	declare flowTourOnboardingService: Service.Flow.Tour.Onboarding;

	get id(): string {
		return TourId.GUIDED_ONBOARDING__DATA_MANAGER_POPULAR;
	}

	override get stepData(): StepData[] {
		return [
			{
				step: 1,
				direction: Direction.UP,
				attachTo: () => {
					return $('.popular-integrations-list');
				},
				focusOverlay: {
					show: true,
					offset: {
						left: -12,
						top: -24,
						width: 24,
						height: 24,
					},
				},
			},
		];
	}
}
